// import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import store from '@/store'
import createUndoHistoryModule, { isMutationType } from '@/store/plugins/undoHistory'
import actions, {
  SET_DEFINITION,
  ADD_ATTRIBUTE,
  REMOVE_ATTRIBUTE,
  UPDATE_ATTRIBUTE,
  UPDATE_OPERATOR,
  CLEAR_DEFINITION,
  CLEAR_SELECTION,
  GROUP,
  UNGROUP,
  MOVE_ATTRIBUTE
} from './actions'

const createModule = (namespace) => {
  /**
   * thinking of passing the names along, lets look at what is required for namespacing....
   * the action for the unHistory can be set in the Actions for the TargetDefinition
   */
  // NAMESPACE add in the namespace here, for the targetDefinition
  return {
    state () {
      return {
        selected: [],
        definition: {
          root: true,
          children: []
        },
        viewOnly: false,
        dragAndDrop: {
          active: false,
          draggingItem: null
        },
        lastTimeTargetWasChanged: null,
        lastAttributeCommand: null,
        updateLasTD: 0
      }
    },
    getters,
    mutations,
    actions,
    modules: {
      ...createUndoHistoryModule(store, {
        // NAMESPACE
        filter: isMutationType([
          ADD_ATTRIBUTE,
          REMOVE_ATTRIBUTE,
          UPDATE_ATTRIBUTE,
          UPDATE_OPERATOR,
          CLEAR_DEFINITION,
          GROUP,
          UNGROUP,
          MOVE_ATTRIBUTE
        ]),
        initialValue: [],
        reducer: state => {
          // NAMESPACE
          // targetDefinition is the namespace for targetDefinition...
          // check that the vueX store has the targetDefinition
          return state[namespace].targetDefinition.definition.children
        },
        restoreState: state => {
          store.dispatch(SET_DEFINITION, state)
          store.dispatch(CLEAR_SELECTION)
        }
      }, {namespace}).module
    }
  }
}

export default createModule



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/targetDefinition/store/index.js